import { defineMessages } from 'react-intl';

// TODO: Deduplicar strings de tamanho - small, large, etc
const messages = defineMessages({
  buttonLabel: { id: 'Button Label', defaultMessage: 'Button Label' },
  labelDescription: {
    id: 'labelButtondescription',
    defaultMessage:
      'If the button is circular, the label will be used for accessibility purposes to describe the icon.',
  },
  button: { id: 'Button', defaultMessage: 'Button' },
  groupButton: { id: 'Group Button', defaultMessage: 'Group Button' },
  buttons: { id: 'Buttons', defaultMessage: 'Buttons' },
  layout: { id: 'Layout', defaultMessage: 'Layout' },
  linkUrl: { id: 'Link URL', defaultMessage: 'Link URL' },
  small: {
    id: 'Small',
    defaultMessage: 'Small',
  },
  default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  large: {
    id: 'Large',
    defaultMessage: 'Large',
  },
  size: {
    id: 'Size',
    defaultMessage: 'Size',
  },
  type: {
    id: 'Type',
    defaultMessage: 'Type',
  },
  primary: {
    id: 'Primary',
    defaultMessage: 'Primary',
  },
  secondary: {
    id: 'Secondary',
    defaultMessage: 'Secondary',
  },
  tertiary: {
    id: 'Tertiary',
    defaultMessage: 'Tertiary',
  },
  magic: {
    id: 'Magic Button',
    defaultMessage: 'Magic Button',
  },
  inverted: {
    id: 'Inverted',
    defaultMessage: 'Inverted',
  },
  align: { id: 'Align', defaultMessage: 'Align' },
  buttonInvertedDescription: {
    id: 'buttonInvertedDescription',
    defaultMessage: 'Change the colors to be used on dark backgrounds.',
  },
  isCircle: {
    id: 'Is Circle',
    defaultMessage: 'Is Circle',
  },
  isCircleDescription: {
    id: 'isCircleDescription',
    defaultMessage:
      'Enable this option to display the button only as a circle with an icon.',
  },
  icon: { id: 'Icon', defaultMessage: 'Icon' },
  iconDescriptionPart1: {
    id: 'Icon description part 1',
    defaultMessage: 'You can find the available icons at',
  },
  iconDescriptionPart2: {
    id: 'Icon description part 2',
    defaultMessage:
      '. For example, you can use "fa-regular fa-calendar" for an Regular Calendar icon. You can browse available icons at Font Awesome Icons Free. Copy the class name and paste it here.',
  },
});

export const buttonSchema = ({ intl }) => {
  return {
    title: intl.formatMessage(messages.button),
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.button),
        fields: ['href', 'isCircle', 'label', 'icon'],
      },
      {
        id: 'layout',
        title: intl.formatMessage(messages.layout),
        fields: ['align', 'size', 'type', 'inverted'],
      },
    ],
    properties: {
      label: {
        title: intl.formatMessage(messages.buttonLabel),
        description: intl.formatMessage(messages.labelDescription),
      },
      href: {
        title: intl.formatMessage(messages.linkUrl),
        widget: 'object_browser',
        mode: 'link',
        selectedItemAttrs: ['Title'],
        allowExternals: true,
      },
      isCircle: {
        title: intl.formatMessage(messages.isCircle),
        default: false,
        description: intl.formatMessage(messages.isCircleDescription),
        type: 'boolean',
      },

      icon: {
        id: 'icon',
        title: intl.formatMessage(messages.icon),
        description: (
          <>
            {intl.formatMessage(messages.iconDescriptionPart1)}{' '}
            <a
              href="https://fontawesome.com/search?ic=free"
              target="_blank"
              rel="noreferrer"
            >
              Font Awesome Icons Free
            </a>
            {intl.formatMessage(messages.iconDescriptionPart2)}
          </>
        ),
      },
      size: {
        title: intl.formatMessage(messages.size),
        isClearable: false,
        noValueOption: false,
        default: 'default',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['default', intl.formatMessage(messages.default)],
          ['small', intl.formatMessage(messages.small)],
          ['large', intl.formatMessage(messages.large)],
        ],
      },
      type: {
        title: intl.formatMessage(messages.type),
        isClearable: false,
        noValueOption: false,
        default: 'secondary',
        type: 'string',
        factory: 'Choice',
        choices: [
          ['primary', intl.formatMessage(messages.primary)],
          ['secondary', intl.formatMessage(messages.secondary)],
          ['tertiary', intl.formatMessage(messages.tertiary)],
          ['magic', intl.formatMessage(messages.magic)],
        ],
      },
      align: {
        title: intl.formatMessage(messages.align),
        widget: 'text_align_widget',
        default: 'center',
        actions: ['left', 'center', 'right'],
      },
      inverted: {
        title: intl.formatMessage(messages.inverted),
        description: intl.formatMessage(messages.buttonInvertedDescription),
        default: false,
        type: 'boolean',
      },
    },
    required: ['label', 'href'],
  };
};
